
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 111 26","width":"111","height":"26","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M0 .5h6.386v11.252h.067L13.513.5h6.69l-8.277 12.467L20.744 25.5h-7.467L6.453 14.689h-.067V25.5H0V.5zM25.742 25.5h6.386V.5h-6.386v25zM47.935 7.988c-.13-.813-.325-2.344-2.213-2.344-1.075 0-2.116.75-2.116 1.89 0 1.431.652 1.724 4.981 3.676 4.49 2.02 5.631 4.103 5.631 6.901 0 3.515-2.019 7.389-8.399 7.389-6.966 0-8.69-4.555-8.69-7.649v-.78h6.118c0 2.798 1.726 3.288 2.508 3.288 1.465 0 2.343-1.205 2.343-2.31 0-1.597-1.008-1.988-4.72-3.551-1.693-.682-5.892-2.377-5.892-6.899 0-4.525 4.395-7.099 8.43-7.099 2.377 0 4.949.882 6.512 2.735 1.432 1.758 1.529 3.387 1.595 4.753h-6.088zM65.705.5l3.344 16.249h.067L72.8.5h4.898l3.614 16.317h.068L84.793.5h6.452l-6.621 25h-5.61L75.267 9.316h-.068L71.448 25.5H65.67L59.22.5h6.486zM96.246.5h13.885v5.609h-7.769v3.883h7.533v5.61h-7.533v4.29h7.769V25.5H96.246V.5z","fill":"#DC2626"}})])
          )
        }
      }
    